// language=HTML
const template = `
    <article class="client-service-contracts">
        <md-content>
            <h1 class="md-display-2 section-title">Client Service Contracts</h1>

            <installation-breadcrumbs></installation-breadcrumbs>

            <md-card class="app-list-card" ng-if="installation.hasServiceContractTypes">
                <app-loading ng-if="fetching" layout-padding></app-loading>

                <md-list ng-if="!fetching">
                    <md-list-item ng-repeat="type in clientServiceContractTypes" class="md-2-line">
                        <md-icon class="md-avatar-icon">content_paste</md-icon>

                        <div class="md-list-item-text">
                            <h3>{{ type.description }}</h3>
                            <p>{{ type.hourly_rate / 100 | currency }}/h</p>
                        </div>
                    </md-list-item>
                </md-list>
            </md-card>

            <form autocomplete="off"
                  name="form"
                  ng-submit="createServiceContractType($event)"
                  ng-disabled="creating">

                <md-card class="app-form-card">
                    <md-card-title>
                        <h2>Add a client service contract type</h2>
                    </md-card-title>

                    <md-card-content>
                        <app-input-text
                            form="form"
                            name="newServiceContractType.description"
                            label="Name"
                            value="newServiceContractType.description"
                            max="255"
                            required>
                        </app-input-text>
                    </md-card-content>

                </md-card>

                <service-contract-type-rates service-contract-type="newServiceContractType"
                                             form="form"
                                             control="formControl">
                </service-contract-type-rates>

                <service-contract-type-billing service-contract-type="newServiceContractType"
                                               form="form">
                </service-contract-type-billing>

                <md-card class="sticky-bottom">
                    <md-card-actions>
                        <md-button type="submit"
                                   class="md-raised md-primary"
                                   ng-disabled="creating || form.$invalid">
                            Create
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </md-content>
    </article>
`;

ClientServiceContractsController.$inject = [
    '$app',
    '$clientServiceContractTypeFetcher',
    '$errorHandler',
    '$installation',
    '$scope',
    '$state',
];

function ClientServiceContractsController(
    $app,
    $clientServiceContractTypeFetcher,
    $errorHandler,
    $installation,
    $scope,
    $state,
) {
    $scope.installation = $installation;
    $scope.creating = false;
    $scope.fetching = false;
    $scope.newServiceContractType = {};

    $scope.formControl = {};

    $scope.createServiceContractType = createServiceContractType;

    fetchContractTypes();

    function fetchContractTypes() {
        $scope.fetching = true;

        $clientServiceContractTypeFetcher
            .all()
            .then(
                response => {
                    $scope.clientServiceContractTypes = response.data;
                },
                error => {
                    $errorHandler.handle(error);
                },
            )
            .finally(() => {
                $scope.fetching = false;
            });
    }

    /**
     * Send the new carer contract type to the server.
     * @return {void}
     */
    function createServiceContractType() {
        const ranges = $scope.formControl.validateHourlyRateRanges();

        if (ranges === false) {
            return;
        }

        const rates = $scope.formControl.validateNonProRataRates();

        if (rates === false) {
            return;
        }

        const charges = $scope.formControl.validateCallOutCharges();

        if (charges === false) {
            return;
        }

        $scope.creating = true;

        const toast = $app.progressToast('Creating contract type');

        const firstRun = !$installation.hasServiceContractTypes;

        $clientServiceContractTypeFetcher
            .create({
                ...$scope.newServiceContractType,
                hourly_rate_ranges: ranges,
                non_pro_rata_rates: rates,
                call_out_charges: charges,
            })
            .then(result => {
                $app.successToast('Contract type created!');
                $scope.clientServiceContractTypes.push(result.data);
                $scope.newServiceContractType = {};

                $installation.hasServiceContractTypes = true;

                if (firstRun) {
                    $state.go($installation.nextStep);
                }
            })
            .catch(error => $errorHandler.handle(error, $scope.form))
            .finally(() => {
                $scope.creating = false;
                toast.hide();
            });
    }
}

export { template, ClientServiceContractsController as controller };
